import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../..';
import { Icon } from '../../icon';
import { SVGFill } from '../../svg';
var bounce = keyframes(["0%,60%,100%{transform:initial;}30%{transform:translateY(-35%);}"]);
var LoadingCircle = styled(SVGFill).attrs(function () {
  return {
    as: 'circle'
  };
}).withConfig({
  displayName: "LoadingIcon__LoadingCircle",
  componentId: "sc-1yn5nfw-0"
})(["animation:1.6s linear infinite ", ";&:nth-of-type(2){animation-delay:0.2s;}&:nth-of-type(3){animation-delay:0.4s;}&:nth-of-type(4){animation-delay:0.6s;}@media (prefers-reduced-motion:reduce){animation:none;&:first-of-type{opacity:0.25;}&:nth-of-type(2){opacity:0.5;}&:nth-of-type(3){opacity:0.75;}}"], bounce);
var LoadingIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var circleRadius = 4;
  var circleOffset = 12;
  return (
    /*#__PURE__*/
    // TODO: this needs a different viewBox after the new icon changes
    React.createElement(Icon, _extends({
      ref: ref,
      viewBox: "0 0 32 32"
    }, props), [0, 1, 2].map(function (circleNumber) {
      return /*#__PURE__*/React.createElement(LoadingCircle, {
        r: circleRadius,
        key: circleNumber,
        cx: circleRadius + circleOffset * circleNumber,
        cy: 15
      });
    }))
  );
});
LoadingIcon.displayName = 'LoadingIcon';
LoadingIcon.defaultProps = {
  // TODO: should this even have anything?
  // 'aria-label': 'Loading',
  svgColor: colors.cheggOrange
};
export default LoadingIcon;